import { Button, Dropdown, Menu, Space, Popconfirm } from "antd";
import {
  DeleteOutlined,
  MoreOutlined,
  EyeOutlined,
  EditOutlined,
  CheckCircleOutlined,
  PhoneOutlined,
  WhatsAppOutlined,
  MailOutlined,
  FileDoneOutlined,
  IdcardOutlined,
  CalendarOutlined,
  ThunderboltOutlined,
  FundOutlined,
} from "@ant-design/icons";
import { isAdmin, isSuperAdmin } from "../../../constants/constent";
import { generateVendorBill } from "../../../utils/common";
import { useState } from "react";
import VendorIdCard from "./VendorIdCard";
import ChangeNextBillingDate from "./ChangeNextBillingDate";
import QuickEditVendor from "./QuickEditVendor";
import VendorBillingDetailModal from "./VendorBillingDetailModal";

function VendorActions({ vendor, onDelete, onVerify, navigate, onRefresh }) {
  const [loading, setLoading] = useState(false);
  const [idCardOpen, setIdCardOpen] = useState(false);
  const [nextDateOpen, setNextDateOpen] = useState(false);
  const [quickEditOpen, setQuickEditOpen] = useState(false);
  const [billingDetailOpen, setBillingDetailOpen] = useState(false);

  return (
    <Space>
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item
              icon={<EyeOutlined />}
              onClick={() => navigate(`/vendor/view/${vendor.id}`)}
            >
              View Detail
            </Menu.Item>
            {(isSuperAdmin() || isAdmin()) && (
              <Menu.Item
                icon={<EditOutlined />}
                onClick={() =>
                  navigate(`/vendor/on-boarding/${vendor.id}/vendor`)
                }
              >
                Edit Value
              </Menu.Item>
            )}
            {(isSuperAdmin() || isAdmin()) && (
              <Menu.Item
                icon={<ThunderboltOutlined />}
                onClick={() => setQuickEditOpen(true)}
              >
                Quick Edit
              </Menu.Item>
            )}
            {isSuperAdmin() && (
              <Menu.Item
                icon={<CheckCircleOutlined />}
                onClick={() => onVerify(vendor.id)}
              >
                Make Verification
              </Menu.Item>
            )}
            <Menu.Item
              icon={<IdcardOutlined />}
              onClick={() => setIdCardOpen(true)}
            >
              Vendor ID Card
            </Menu.Item>
            {(isSuperAdmin()) && (
              <Menu.Item
                icon={<CalendarOutlined />}
                onClick={() => setNextDateOpen(true)}
              >
                Change Next Billing Date
              </Menu.Item>
            )}
            {isSuperAdmin() && vendor.status === "active" && (
              <>
                {/* Hide once the setup charge is already completed/paid */}
                {!vendor.setup_charage_status && (
                  <Menu.Item
                    icon={<FileDoneOutlined />}
                    onClick={() =>
                      generateVendorBill(
                        { vendor_id: vendor.id, bill_type: "setup" },
                        setLoading,
                      )
                    }
                  >
                    Generate Setup Bill
                  </Menu.Item>
                )}
                <Menu.Item
                  icon={<FileDoneOutlined />}
                  onClick={() =>
                    generateVendorBill(
                      { vendor_id: vendor.id, bill_type: "subscription" },
                      setLoading,
                    )
                  }
                >
                  Generate Subscription Bill
                </Menu.Item>
                <Menu.Item
                  icon={<FileDoneOutlined />}
                  onClick={() => navigate(`/vendor/bills/${vendor.id}`)}
                >
                  Generated Bills
                </Menu.Item>
              </>
            )}
            {(isSuperAdmin() || isAdmin()) && (
              <Menu.Item
                icon={<FundOutlined />}
                onClick={() => setBillingDetailOpen(true)}
              >
                Billing &amp; Finance Details
              </Menu.Item>
            )}
            {isSuperAdmin() && (
              <Menu.Item
                danger
                icon={<DeleteOutlined />}
                onClick={() => navigate(`/vendor/purge/${vendor.id}`)}
              >
                Delete All Data
              </Menu.Item>
            )}
            <Menu.Item icon={<PhoneOutlined />}>
              <a
                href={`tel:${vendor.hotel_mobile_no}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Call: {vendor.hotel_mobile_no}
              </a>
            </Menu.Item>
            <Menu.Item icon={<WhatsAppOutlined />}>
              <a
                href={`https://wa.me/${vendor.hotel_whatsapp_no}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp: {vendor.hotel_whatsapp_no}
              </a>
            </Menu.Item>
            <Menu.Item icon={<MailOutlined />}>
              <a
                href={`mailto:${vendor.hotel_email_id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Email: {vendor.hotel_email_id}
              </a>
            </Menu.Item>
          </Menu>
        }
      >
        <Button type="dashed" loading={loading} disabled={loading}>
          <MoreOutlined />
        </Button>
      </Dropdown>

      {isSuperAdmin() && (
        <Popconfirm
          title="Delete Vendor?"
          onConfirm={() => onDelete(vendor.id)}
        >
          <Button danger loading={loading} disabled={loading}>
            <DeleteOutlined />
          </Button>
        </Popconfirm>
      )}

      {/* ================= REUSABLE MODALS ================= */}
      <VendorIdCard
        vendor={vendor}
        asModal
        open={idCardOpen}
        onClose={() => setIdCardOpen(false)}
      />
      <ChangeNextBillingDate
        vendor={vendor}
        asModal
        open={nextDateOpen}
        onClose={() => setNextDateOpen(false)}
        onSaved={() => {
          setNextDateOpen(false);
          if (onRefresh) onRefresh();
        }}
      />
      <QuickEditVendor
        open={quickEditOpen}
        vendorId={vendor.id}
        onClose={() => setQuickEditOpen(false)}
        onSaved={() => {
          setQuickEditOpen(false);
          if (onRefresh) onRefresh();
        }}
      />
      <VendorBillingDetailModal
        open={billingDetailOpen}
        vendorId={vendor.id}
        onClose={() => setBillingDetailOpen(false)}
      />
    </Space>
  );
}

export default VendorActions;
